import { GridCol, mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  @media print {
    display: none;
  }
  color: ${({ theme }) => theme.colorTheme.fontColor};
  background: ${({ theme }) => theme.colorTheme.bgColor};

  padding-top: 70px;
  padding-bottom: 70px;
  ${mixins.media.min.desktop} {
    padding-top: 100px;
    padding-bottom: 100px;
  }
`

export const Title = styled.h2`
  ${mixins.typography.noColor.headlineMedium};
  font-weight: 400;
  ${mixins.media.max.desktop} {
    display: none;
  }
`

export const StyledButton = styled.button`
  ${({ theme }) => mixins.cta.tertiary(theme.colorTheme.fontColor)};

  ${mixins.media.min.desktop} {
    display: none;
  }
  & > span {
    ${mixins.typography.noColor.headlineMedium};
    font-weight: 400;
    text-transform: none;
  }
`

export interface ButtonWrapperProps {
  mobileShow: boolean
}

export const ButtonWrapper = styled(GridCol)<ButtonWrapperProps>`
  display: ${({ mobileShow }) => (mobileShow ? 'flex' : 'none')};
  flex-direction: column;
  margin-top: 20px;
  ${mixins.media.min.desktop} {
    flex-direction: row;
    display: flex;
    margin-top: 0;
  }
  justify-content: space-around;
  width: 100%;
`
export const Link = styled.a`
  ${({ theme }) => mixins.cta.hyperlink(theme.colorTheme.fontColor)};

  & {
    ${mixins.padding(10)}
  }

  ${mixins.media.min.desktop} {
    flex-direction: column;

    & > svg {
      ${mixins.margin.bottom(5)}

      &:first-child,&:last-child {
        ${mixins.margin.right(0)}
      }
    }
  }
`
